import { Component, OnInit, OnChanges, SimpleChanges , ViewChild, TemplateRef, Input,Output,EventEmitter, Injectable} from '@angular/core';
import { IHaloDropDown } from 'src/app/core/halo-dropdown/halo-dropdown.interface';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { NgbDateParserFormatter, NgbDateStruct, NgbInputDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from 'src/app/core/date-range-picker/ngb-date-parser-formatter';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { StaffService } from 'src/app/post-login/services/staff.service';
import { IStaffResponse } from 'src/app/post-login/services/staff.model';
import { Subscription } from 'rxjs';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { environment } from 'src/environments/environment';
import { ESupportType,SuperFooterService } from 'src/app/core/services/super-footer.service';
@Component({
  selector: 'app-complete-dialog',
  templateUrl: './complete-dialog.component.html',
  styleUrls: ['./complete-dialog.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
   ]
})

export class CompleteDialogComponent implements OnInit {
  @Input() source: string;
  @Input() action: 'warning'|'dismiss'|'complete';
  @Input() data: any;
  @Input() openModal: boolean;
  @Output() saveModal = new EventEmitter<object>();
  @Output() closeModal = new EventEmitter<boolean>();
  @ViewChild('titleTemplateComplete') titleTemplateComplete: TemplateRef<any>;
  @ViewChild('bodyTemplateComplete') bodyTemplateComplete: TemplateRef<any>;
  @ViewChild('footerTemplateComplete') footerTemplateComplete: TemplateRef<any>;
  staffList = [] as any[];
  todayDate = new Date();
  completedBy = {value:"",text:"",emailAddress:''};
  completedDate: NgbDateStruct = { year: this.todayDate.getFullYear(), month: this.todayDate.getMonth() + 1, day: this.todayDate.getDate() };
  completedNotes = "";
  rootScopeData: RootScopeDeclare;
  ddConfig: NgbInputDatepickerConfig;
  config: NgbInputDatepickerConfig;
  sub = new Subscription();
  constructor(private _modal: HaloModalService,private _commonUtil: CommonUtil,private _facilityService: FacilityService,
    private _staffService: StaffService,private _rootScopeService: RootScopeService,config: NgbInputDatepickerConfig,    
    private amplitudeAnalytics: AmplitudeAnalyticsService,private supportService: SuperFooterService) {
      this.config = config;
   }

  ngOnInit(): void {
    const _facilityOnChangeSub = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.onCancelClick();
    });
    this.sub.add(_facilityOnChangeSub);

    this.rootScopeData = this._commonUtil.rootScopeData; 
    this.completedBy = {value:this.rootScopeData.currentUser.userId.toString(),text:this.rootScopeData.currentUser.displayName, emailAddress: this.rootScopeData.currentUser.emailAddress.toString()};
    this.config.maxDate = { year: this.todayDate.getFullYear(), month: this.todayDate.getMonth() + 1, day: this.todayDate.getDate() };
    this.config.showWeekdays = true;
    this.config.container = 'body';
    this.config.navigation = "arrows";
    this.ddConfig = Object.assign({}, this.config);
  }
  
  async ngOnChanges(changes: SimpleChanges) {
    if(changes.openModal && changes.openModal.currentValue !== changes.openModal.previousValue && changes.openModal.currentValue === true){
      await this.getManagerList();
      this._modal.add({
        dismissible: true,
        titleUppercase: true,
        modalSize: HaloModalSize.Medium,
        onDismiss: this.onDismiss,
        titleTemplate: this.titleTemplateComplete,     
        bodyTemplate: this.bodyTemplateComplete,
        footerTemplate: this.footerTemplateComplete,
        isVideoTree:false,
      });
    }

    if(changes.openModal && changes.openModal.currentValue !== changes.openModal.previousValue && changes.openModal.currentValue === false){
      this.rootScopeData = this._commonUtil.rootScopeData;
      this.resetOnCancelStage();
      this._modal.close();
    }

    if(changes.data && changes.data.currentValue && changes.data.currentValue !== changes.data.previousValue){
      console.log('---data----',changes.data.currentValue);
    }
  }
  
  private async getManagerList() {
    if (this.staffList?.length < 1 && this._facilityService.selectedFacilityId()) {  
      try {
        const data = await this._staffService.getList(this._facilityService.selectedFacilityId()).toPromise();
        this.staffList = data.manager.map((val:any) => {return{"value":val.userId,"text":val.firstName+" "+val.lastName,"emailAddress":val.emailAddress}});
      } catch (error) {
        console.error('API failed.');
      }
    }
  }

  onSaveClick(){
    const nDate = new Date();
    const nTime = nDate.getHours()+':'+ nDate.getMinutes()+':'+ nDate.getSeconds();
    const dateString = this.completedDate.year+"-"+this.completedDate.month+"-"+this.completedDate.day+' '+nTime;
    if(this.source === "equipmentRotations"){
      let cmpObj = {
        "action":"complete",
        "activityId": Number(this.data.activityId),
        "completedTimestamp":new Date(dateString).getTime(),
        "completedUserName": this.completedBy.text,
        "facilityId": Number(this._facilityService.selectedFacilityId()),
        "highUseEquipmentId": Number(this.data.highUsageEquipment.assetId),
        "lowUseEquipmentId": Number(this.data.lowUsageEquipment.assetId),
        "notes": this.completedNotes,
        "userEmail": this.rootScopeData.currentUser.emailAddress
      }
      this.saveModal.emit(cmpObj);   
    }else{
      const cmpObj = {
        "action": "complete",
        "assetId": this.data?.assetId,
        "completedTimestamp":new Date(dateString).getTime(),
        "completedUserName": this.completedBy.text,
        "facilityId": Number(this._facilityService.selectedFacilityId()),
        "notes": this.completedNotes,
        "userEmail": this.completedBy.emailAddress
      }
      this.saveModal.emit(cmpObj);   
    } 
  }

  onCancelClick(){   
    if(this.source === 'errorCodes' && (this.action === 'complete' || this.action === 'dismiss')){
      this.resetOnCancelStage();
      this.action = 'warning';
    }else{
      this.resetOnCancelStage();
      this._modal.close();  
      this.closeModal.emit(true); 
    }     
  }

  onCompleteErrorCodeClick(){
    this.action = 'complete';
  }

  onDismissErrorCodeClick(){
   this.action = 'dismiss';
  }

  onDimissErrorCodeActionClick(status:'COMPLETE'|'DISMISS'|'NO'){
    if(status === 'COMPLETE'){
      const nDate = new Date();
      const nTime = nDate.getHours()+':'+ nDate.getMinutes()+':'+ nDate.getSeconds();
      const dateString = this.completedDate.year+"-"+this.completedDate.month+"-"+this.completedDate.day+' '+nTime;
      let cmpObj = {
        "errorCodeId": this.data.errorCodeId,
        "assetId": this.data.assetId,
        "errorCode": this.data.code,
        "errorCodeDesc": this.data.codeDesc,
        "occurredDate": this.data.occurredDate,
        "action": "complete",
        "notes": this.completedNotes,
        "completedUserName": this.completedBy.text,
        "userEmail": this.completedBy.emailAddress,
        "completedTimestamp": new Date(dateString).getTime()
      };
      this.action = 'warning';
      this.saveModal.emit(cmpObj);
    }else if(status === 'DISMISS'){
      let cmpObj = {
        "errorCodeId": this.data.errorCodeId,
        "assetId": this.data.assetId,
        "errorCode": this.data.code,
        "errorCodeDesc": this.data.codeDesc,
        "occurredDate": this.data.occurredDate,
        "action": "dismiss",
        "completedUserName": this.rootScopeData.currentUser.displayName,
        "userEmail": this.rootScopeData.currentUser.emailAddress,
        "completedTimestamp": new Date().getTime()
      };
      this.action = 'warning';
      this.saveModal.emit(cmpObj);
    }
    else{
      this.onCancelClick();
    }
  }

  onClickTechnicianVisit(){
    this.onCancelClick();
    this.supportService.switchForm(ESupportType.TECHNICIAN_VISIT);
  }

  resetOnCancelStage(){    
    this.completedDate = { year: this.todayDate.getFullYear(), month: this.todayDate.getMonth() + 1, day: this.todayDate.getDate() };
    this.completedBy = this.rootScopeData?{value:this.rootScopeData.currentUser.userId.toString(),text:this.rootScopeData.currentUser.displayName, emailAddress: this.rootScopeData.currentUser.emailAddress.toString()}:{value:"",text:"", emailAddress:""};
    this.completedNotes = "";
  }

  staffDropdownChanged(selected: any | null) {    
    this.completedBy = selected;
  }

  onDateSelect(event:any){
  }


  onDismiss() {
    //...
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
  
  onOrderParts() {
    this.amplitudeAnalytics.logEvent({elementName: 'Order Belt', action: 'Click'});
    if (localStorage.getItem('ssoFederated') != null && localStorage.getItem('ssoFederated') == 'true') {
      let url = 'ibeCAcpSSOLogin.jsp';
      if(!(this.data?.bodySerial.indexOf(':') > -1)) url = 'ibeCAcpSSOLogin.jsp?ref=xxlfps_ibeCSrdSRNumSrchResults.jsp%253Fserial=';
      this._commonUtil.openOnNewTab(`https://external-xtst.lifefitness.com/OA_HTML/${url}${this.data.bodySerial}`);
    } else {
      let url = 'ibeCZzpHome.jsp';
      if(!(this.data?.bodySerial.indexOf(':') > -1)) url = 'xxlfps_ibeCSrdSRNumSrchResults.jsp?serial=';
      this._commonUtil.openOnNewTab(`https://external-xtst.lifefitness.com/OA_HTML/${url}${this.data.bodySerial}`);
    }
  }
}
